// extracted by mini-css-extract-plugin
module.exports = {"list":"Rating_list__zzSsm","item":"Rating_item__1kJ0N","filled":"Rating_filled__3Wynx","fill":"Rating_fill__23Wsg"};